import React from 'react'

const Fallback = ({ error }) => {
  return (
    <div>
      <p>
        Oops. Something went wrong. Try again later.
      </p>
      <p>
        {JSON.stringify(error, null, 4)}
      </p>
    </div>
  )
}

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { 
      info: null,
      error: null
    };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    this.setState({ error, info })
  }

  render() {
    if (this.state.error) {
      // You can render any custom fallback UI
      return <Fallback error={this.state} />
    }

    return this.props.children;
  }
}